<template>
  <div class="identifyBox1">
    <div>
      <van-nav-bar :title="title" left-arrow @click-left="$router.back(-1)" :style="{paddingTop:statusBarHeight+'px'}"/>
    </div>
    <div class="identifyBox">
        <div class="top" v-if="isinstructions">
            <img class="liulanqidakai" src="../../../assets/images/exam/liulanqidakai.png" alt="" />
        </div>
      <div class="contentBox">
        <div class="weidong">
          <img
            src="../../../assets/images/exam/weidong.png"
            alt=""
          />
        </div>
        <div class="text">
          为保证考试严肃性
        </div>
        <div class="text">
          正式考试需在APP中参加
        </div>
        <van-button @click="handleApp()" class="btn">下载APP</van-button>
      </div>
      <div class="bottom">
        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/exam/background.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "identify",
  data() {
    return {
      title: "",
      isinstructions: false,
      statusBarHeight:0,
      bottomSafeHeight:0
    };
  },

  methods: {
    handleApp() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        // window.location.href = `xlsxapp://requiopqkl5u9rlwgj3tputr`; // ios app协议
        window.location.href = "itms-apps://itunes.apple.com/app/id1537761202";
      } else if (navigator.userAgent.match(/android/i)) {
        // window.location.href = `xlsx://parent/enterTeacherClassDetailVideo`; // android app协议 其中miniCourseId 就是扫码获取的url里面的miniCourseId
        window.location.href =
          "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/android/android.apk"; // android 下载地址
      }
    },
  },

  created() {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
      this.isinstructions = true;
    } else {
      this.isinstructions = false;
    }
    if(localStorage.getItem('type') == 'iOS') {
            this.statusBarHeight = localStorage.getItem("statusBarHeight");
            this.bottomSafeHeight = localStorage.getItem("bottomSafeHeight");
        }
  },
};
</script>
<style lang='less' scoped>

.identifyBox1 {
    height: 100%;
    
    .identifyBox{
        
        .top{
            width: 100%;
            text-align: right;
            margin-top: 16px;
        }
        .liulanqidakai{
            width:300px;
            height: 170px;
            margin-right: 54px;
        }
        .contentBox{
            width: 100%;
            margin-top:70px;
        }
        .weidong {
            margin: 0 auto;
            width: 276px;
            height: 276px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .text{
            text-align: center;          
            font-size: 36px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #202124;
            line-height: 54px;
        }
        .van-button--normal{
            margin: 0 auto;
            margin-top: 1.706rem;
            margin-left: 2.933rem;
            width: 14.133rem;
            height: 2.346rem;
            background: linear-gradient(136deg, #227FFF 0%, #316FFF 100%);
            box-shadow: 0px 0.426rem 1.28rem 0px rgba(83,112,221,0.3);
            border-radius: 100px;
            font-size: 0.96rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }
        .bottom{
            width: 100%;
            height: 400px;
            position: fixed;
            bottom: 0px;
            img {
                width: 100%;
                height: 100%;  
            }
        }
    }
}
</style>